import React  from 'react';

import AboutContent from "../content/AboutContent";

import Navbar from "../inc/Navbar";
import BannerInner from "../inc/BannerInner";
import Footer from "../inc/Footer";

function About() {
    return(
        <>
        <Navbar />
        <BannerInner />
        <AboutContent />
        <Footer />        
        </>
    );
}

export default About;